import BytesToMinimumGB from '../../../../util/BytesToMinimumGB';

export default function getHotStorage(value, row) {
  if (!row) {
    return { used: 0, total: 0 };
  }
  if (row.state && row.state.storage) {
    const storage = row.state.storage;
    const hot_total = storage.hot_total;
    const hot_available = storage.hot_available;
    if (hot_total !== undefined && hot_available !== undefined) {
      return {
        used: BytesToMinimumGB(hot_total - hot_available) || 0,
        total: BytesToMinimumGB(hot_total) || 0,
      };
    }
  }
  return { used: 0, total: 0 };
}
